import sentinel_img from "./img/sentinel.jpg";
import boilerplate_img from "./img/boilerplate.jpg";
import newtabpage_img from "./img/newtabpage.jpg";
import urli_img from "./img/urli.jpg";
import docuhub_img from "./img/docuhub.jpg";

export default [
  {
    sourceCode: "https://github.com/denis-onder/ts-node-api-boilerplate",
    name: "TypeScript Node API Boilerplate",
    img: boilerplate_img,
  },
  {
    sourceCode: "https://github.com/denis-onder/sentinel-rebooted",
    link: "https://infinite-atoll-23647.herokuapp.com/",
    name: "Sentinel",
    desc: "A free, open-source password manager.",
    img: sentinel_img,
  },
  {
    sourceCode: "https://github.com/denis-onder/tab-page-replacement",
    link: "https://new-tab.xyz",
    name: "New Tab/Home Page Replacement",
    desc: "A new tab page for your browser.",
    img: newtabpage_img,
  },
  {
    sourceCode: "https://github.com/denis-onder/url-shortener",
    link: "http://www.urli.xyz",
    name: "urli.xyz",
    desc: "URL Shortening Extraordinaire.",
    img: urli_img,
  },
  {
    sourceCode: "https://github.com/denis-onder/docuhub",
    link: "https://docuhub.netlify.app/",
    name: "docuhub",
    desc: "Get your documentaries.",
    img: docuhub_img,
  },
];
